import { styled, TableCell, tableCellClasses, TableRow } from '@mui/material';

export const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.body}`]: {
    fontFamily: "'Open Sans', sans-serif",
  },
  [`&.${tableCellClasses.head}`]: {
    fontFamily: "'Open Sans', sans-serif",
  },
}));

export const StyledTableRow = styled(TableRow)(() => ({
  '&:nth-of-type(odd)': {
    backgroundColor: '#fafbfc',
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

export const BorderBottomTableCell = styled(TableCell)(
  {
    borderWidth: '0 0 1px',
    borderStyle: 'solid',
    borderColor: 'rgba(224, 224, 224, 1)',
  }
)

export const StyledPracticeCell = styled(BorderBottomTableCell)(
  {
    textTransform: 'capitalize',
    paddingTop: 0,
    paddingBottom: 0,
  }
)

export const BorderLessTableCell = styled(TableCell)(
  {
    width: 100,
    border: 'none',
    paddingTop: 0,
    paddingBottom: 0,
  }
)